import React from 'react';
import type { NavLinkProps, NavLinkComponent } from './types';

/** ตัวสำรองเมื่อ host ไม่ได้ส่ง linkComponent มา — ไม่พึ่ง router ใด ๆ */
export const DefaultNavLink: NavLinkComponent = ({ to, children, className, style }) => (
  <a href={to} className={className} style={style}>
    {children}
  </a>
);

/** ใช้ในหน้าจอ: const Link = resolveLink(props.linkComponent) */
export const resolveLink = (linkComponent?: NavLinkComponent): NavLinkComponent =>
  linkComponent ?? DefaultNavLink;
